import { render, staticRenderFns } from "./popularBrands.vue?vue&type=template&id=0218dda2"
import script from "./popularBrands.vue?vue&type=script&lang=js"
export * from "./popularBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports